import React from 'react';
import { Info } from 'lucide-react';
import { Button } from '../../../catalyst/button';

const ManualWaypointModal = ({ 
  isOpen, 
  onClose, 
  manualWaypoint, 
  setManualWaypoint, 
  waypointsLength,
  onSave 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="px-6 py-4 border-b border-gray-200">
          <h3 className="text-lg font-medium text-gray-900">Add Waypoint</h3>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Waypoint Name (Optional)
            </label>
            <input
              type="text"
              value={manualWaypoint.name}
              onChange={(e) => setManualWaypoint({...manualWaypoint, name: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder={`WP${waypointsLength + 1}`}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Latitude</label>
              <input
                type="text"
                value={manualWaypoint.lat}
                onChange={(e) => setManualWaypoint({...manualWaypoint, lat: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="50.7500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Longitude</label>
              <input
                type="text"
                value={manualWaypoint.lng}
                onChange={(e) => setManualWaypoint({...manualWaypoint, lng: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                placeholder="-1.2500"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Notes (Optional)</label>
            <textarea
              value={manualWaypoint.notes}
              onChange={(e) => setManualWaypoint({...manualWaypoint, notes: e.target.value})}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              rows={2}
              placeholder="Any notes about this waypoint"
            />
          </div>
          <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-start gap-2">
              <Info className="h-4 w-4 text-blue-600 mt-0.5" />
              <p className="text-sm text-blue-800">
                Enter coordinates in decimal degrees (e.g., 50.7500, -1.2500)
              </p>
            </div>
          </div>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <Button color="white" onClick={onClose}>
            Cancel
          </Button>
          <Button color="indigo" onClick={onSave}>
            Add Waypoint
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManualWaypointModal;